<div
  class="home-section md:ml-2"
  *ngIf="venue$ | async as venue; else fullScreenLoading"
>
  <div class="event-date-detail">
    <!-- TEMP DISABLE UNTIL FIX CALENDER VIEW ISSUE -->
    <a
      class="tix-calendar-view-btn"
      routerLink="calendar-view"
      (click)="trackButtonClick('Calendar View')"
    >
      <span>Calendar View </span>
      <tix-icon svgIcon="arrow-right-solid" class="!w-4 !h-4"></tix-icon>
    </a>
    <div
      class="bg-white pr-6 pl-6 sm:pl-6 2xl:pl-6 pb-6 sm:pt-10 flex flex-col-reverse items-stretch tix-event-content lg:flex-col"
    >
      <tix-event-calendar
        *ngIf="!isSingleEventPage"
        class="lg:block hidden"
        [venueId]="venueId"
        [events]="events"
        [initialFilter]="selectedCalendarDateFilter ?? undefined"
        (updateCalendarFilter)="updateCalendarFilter($event)"
      ></tix-event-calendar>
      <tix-venue-info
        class="mb-0 sm:mb-3 lg:mb-0"
        [venueId]="venue.venueId"
        [venueDetail]="venue"
      ></tix-venue-info>
    </div>
  </div>

  <div class="event-content-detail">
    <tix-event-calendar
      class="lg:hidden"
      [venueId]="venueId"
      [events]="events"
      (updateCalendarFilter)="updateCalendarFilter($event)"
    ></tix-event-calendar>

    <div class="event-search-input !mb-6 relative" *ngIf="!isSingleEventPage">
      <input
        tixInput
        type="text"
        placeholder="Search events...."
        [formControl]="searchQueryControl"
      />
      <button tix-button type="button" class="search-icon">
        <tix-icon svgIcon="search-icon-solid"></tix-icon>
      </button>
      <button
        *ngIf="searchQuery"
        (click)="searchQueryControl.setValue('')"
        class="absolute px-2 py-1 text-gray-500 -translate-y-1/2 rounded-md hover:text-primary hover:bg-primary bg-opacity-20 hover:bg-opacity-20 right-4 lg:right-14 top-1/2"
      >
        Clear
      </button>
    </div>

    <div class="row">
      <ng-container *ngIf="!isLoadingFirstPageEvents; else loading">
        <ng-container *ngIf="events.length > 0; else noItems">
          <tix-events-list
            *ngFor="let event of events"
            [event]="event"
            [venueDetail]="venue"
            [venueId]="venue.venueId"
          ></tix-events-list>
        </ng-container>

        <ng-container
          *ngIf="!isLoadingNextPageEvents; else loading"
        ></ng-container>

        <ng-container *ngIf="hasReachedTheEnd && events.length > 5">
          <p class="my-4 text-center mx-auto text-gray-500">
            No more events available
          </p>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noItems>
  <tix-empty-state
    title="No Available Events"
    subTitle="Try to select another date"
  ></tix-empty-state>
</ng-template>

<ng-template #fullScreenLoading>
  <div class="h-screen w-full flex items-center justify-center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<ng-template #loading>
  <div class="my-4 w-full flex items-center justify-center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
